"use client";

import { useEffect, useState } from "react";
import { Guest } from "../types";
import { GuestList } from "../components/guest-list";
import { Container } from "../components/container";
import { getGuests } from "./getGuests";
import { LoadMore } from "../components/load-more";

type Props = {
  initialGuests: Guest[];
  initialPage: number;
  pageCount: number;
  title: string;
};

export const GuestPageList = ({
  initialGuests,
  initialPage,
  pageCount,
  title,
}: Props) => {
  const [guests, setGuests] = useState<Guest[]>(initialGuests);
  const [page, setPage] = useState(initialPage);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (page === initialPage) return;

    setIsLoading(true);

    getGuests(page)
      .then((response) => {
        setGuests((prev) => [...prev, ...(response?.data ?? [])]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [page, initialPage]);

  return (
    <Container>
      <GuestList guests={guests} title={title} showAllGuests={false} />
      {pageCount > 0 && <LoadMore disabled={isLoading || page >= pageCount} isLoading={isLoading} onClick={() => setPage((p) => p + 1)} />}
    </Container>
  );
};
